import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import { notificationService } from '@/services/notification/notification.client';
import GetVarBillingUsageDetailsQuery from '@/graphql/contracts/getVarBillingUsageDetails.query.gql';
import GetVarBillingUsageHeaderQuery from '@/graphql/contracts/getVarBillingUsageHeader.query.gql';
import MatchUsageDetailsMutation from '@/graphql/contracts/matchUsageDetails.mutation.gql';
import { MatchUsageDetails, MatchUsageDetailsVariables } from
  '@/graphql/contracts/_generated_/matchUsageDetails.mutation';
import { USAGE_RECORDS_PER_PAGE } from '@/config/common.config';

import GetVarBillingUsageDetailsStatsQuery from '@/graphql/contracts/getVarBillingUsageDetailsStats.query.gql';
import { MatchUsageDetailsInputType } from '@/graphql/contracts/_generated_/contracts';

export default function useMatchUsageDetails() {
  const { fileId }: { fileId: string } = useParams();
  const [_matchUsageDetails, { loading }] = useMutation<MatchUsageDetails, MatchUsageDetailsVariables>(
    MatchUsageDetailsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    },
  );

  const matchUsageDetails = (usageHeader: MatchUsageDetailsInputType, successCb?: () => void) => {
    _matchUsageDetails({
      variables: { input: usageHeader },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetVarBillingUsageDetailsQuery,
          variables: {
            first: USAGE_RECORDS_PER_PAGE,
            filter: {
              headerPrimaryKey: { eq: usageHeader.usageHeaderId }
            },
          },
        },
        {
          query: GetVarBillingUsageHeaderQuery,
          variables: {
            id: fileId
          },
        },
        {
          query: GetVarBillingUsageDetailsStatsQuery,
          variables: {
            filter: {
              headerPrimaryKey: { eq: usageHeader.usageHeaderId }
            },
          },
        },
      ],
      onCompleted: () => {
        successCb?.();
        notificationService.open({
          title: 'Match Usage Header',
          text: 'Usage header matching is in progress...',
          type: 'warning'
        });
      }
    });
  };

  return {
    matchUsageDetails,
    isLoadingMatchUsageDetails: loading
  } as const;
}
